'use strict';

var FirebaseIndirectArray = require('./FirebaseIndirectArray');
var KayleeBase = require('./KayleeBase');
var KayleeCache = require('./KayleeCache');
var KayleeDirectory = require('./KayleeDirectory');
var KayleeUtil = require('./KayleeUtil');
var log = require('../log/Log').channel('KayleeDirectories');

var KayleeDirectories = {
    fromJson: fromJson,
    getDirectories: getDirectories,
};

function fromJson(data) {
    var reqProps = [ '$nodeCacheKey' ];
    return FirebaseIndirectArray.$fromJson(data, 'Directories', reqProps, reqProps,
        function(data) {
            var node = KayleeCache.get(data.$nodeCacheKey);
            return getDirectories(node);
        }
    );
}

function getDirectories(node) {
    var key = 'Directories: ' + node.$id;
    var directories = KayleeCache.get(key);

    if (directories === null) {
        directories = new Directories(node);
        KayleeCache.put(key, directories);
    }

    return directories;
}

function Directories(node) {
    var self = this;

    self.$node = node;
    self.$nodeType = 'directories';

    if (node.$nodeType === 'company') {
        FirebaseIndirectArray.call(self,
            KayleeBase.app.database()
                .ref('index/directoriesByCompany/' + node.$id),
            KayleeDirectory.getDirectory);
    } else if (node.$nodeType === 'room') {
        FirebaseIndirectArray.call(self,
            KayleeBase.app.database()
                .ref('rooms/' + node.$id + '/settings/companyDirectories'),
            KayleeDirectory.getDirectory);
    } else {
        log.error('invalid node type: ' + node.$nodeType);
    }

    KayleeUtil.bindPrototypeMethods(Directories.prototype, self, self.$items);
    this.$items.$self = this;

    return self.$items;
}

Directories.prototype = Object.create(FirebaseIndirectArray.prototype);
Directories.prototype.constructor = Directories;

Directories.prototype.$toJson = function() {
    return FirebaseIndirectArray.prototype.$toJson.call(this,
        [], { $nodeCacheKey: this.$node.$cacheKey });
};

Directories.prototype.$addDirectory = function(name, entries) {
    if (this.$node.$nodeType !== 'company') {
        log.error('$addDirectory: invalid node type: ' + this.$node.$nodeType);
        return Promise.reject(new Error('invalid node type'));
    }

    var updates = {};
    var directoryId = KayleeBase.app.database().ref().push().key;
    updates['/index/directoriesByCompany/' + this.$node.$id + '/' + directoryId] = true;
    updates['/directories/' + directoryId] = {
        name: name,
        type: 'company',
        created: Date.now(),
        modified: Date.now(),
        companyId: this.$node.$id,
        entries: entries,
    };

    return KayleeBase.update(updates).then(function() {
        return Promise.resolve(directoryId);
    });
};

Directories.prototype.toString = function() {
    return '[Directories for ' + this.$room + ']';
};

module.exports = KayleeDirectories;
